import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import rootReducer from './index';
import logger from 'redux-logger';
import { isDev } from '../Lib/config';

const store = configureStore({
    reducer: rootReducer,
    preloadedState: {},
    devTools: isDev,
    middleware: getDefaultMiddleware =>
        isDev ? getDefaultMiddleware().concat(logger) : getDefaultMiddleware(),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
